<template>
    <transition  name="custom-classes-transition" enter-active-class="animate__animated animate__backInRight"
        leave-active-class="animate__animated animate__zoomOut">
        <div class="honor-container" v-if="visible">
            <el-carousel :interval="30000" height="100vh" width="100vw" :autoplay="false">
                <el-carousel-item v-for="(item, index) in banner" :key="index">
                    <img :src="item" style="width:70vw;height:70vh;margin-left:15vw;margin-top: 15vh;"></img>
                </el-carousel-item>
            </el-carousel>
        </div>
    </transition>
</template>
<script>
export default {
    name: 'honorBox',
    data() {
        return {
            visible: false,
            banner: []
        }
    },
    methods: {
        init(banner) {
            console.log('banner', banner)
            this.banner = banner
            this.visible = true
        },
        hide() {
            this.visible = false
        }
    }
}
</script>
<style lang="less" scoped>
.honor-container {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(255, 255, 255, .4);
    border-radius: 10px;

    .slide-fade-enter-active {
        transition: all 8.3s ease;
    }

    .slide-fade-leave-active {
        transition: all 8.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter,
    .slide-fade-leave-to

    /* .slide-fade-leave-active for below version 2.1.8 */
        {
        transform: translateX(10px);
        opacity: 0;
    }

    p {
        border: 1px solid red;
        width: 300px;
    }
}
</style>